import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "_api"; // Adjust the import path to your API configuration

// Thunk สำหรับ fetch ข้อมูล
export const fetchOverdueData = createAsyncThunk(
  "overdue/fetchData",  // ชื่อ action ของ overdue
  async (_, { rejectWithValue }) => {
    try {
      const { data, isStatus } = await api.product.getOverDueOrders();
      if (isStatus) return data; // ส่งข้อมูลกลับไปให้ slice
      return rejectWithValue("Error fetching data");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const overdueSlice = createSlice({
  name: "overdue",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverdueData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOverdueData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOverdueData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default overdueSlice.reducer;
